import React from "react";
import YoutubeVideo from "./youtubeVideo";
import YoutubeVideoContainer from "./youtubeVideoContainer";

interface State {
    currentVideo: number;
}

interface Props {
    videos: Array<YoutubeVideo>;
}

/**
 * Displays the carousel containing various youtube videos
 */
export default class YoutubeCarousel extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            currentVideo: 0,
        };
    }

    render() {
        let videos = Array<JSX.Element>();
        let count = 0;
        for (let video of this.props.videos) {
            let active = "";
            if (count === 0) {
                active = "active";
            }
            videos.push(
                <div
                    className={"carousel-item " + active}
                    key={video.embedCode}
                >
                    <YoutubeVideoContainer video={video} />
                </div>
            );
            count++;
        }

        // return <div className="row youtube-video-container">{videos}</div>;

        return (
            <div className="row video-row mb-5 pb-4">
                <div className="col-12">
                    <div
                        id="videoCarousel"
                        className="carousel slide"
                        data-bs-ride="false"
                        data-bs-interval="false"
                    >
                        <div className="carousel-inner">{videos}</div>
                        <button
                            className="carousel-control-prev"
                            type="button"
                            data-bs-target="#videoCarousel"
                            data-bs-slide="prev"
                        >
                            <span
                                className="carousel-control-prev-icon"
                                aria-hidden="true"
                            />
                            <span className="visually-hidden">Previous</span>
                        </button>
                        <button
                            className="carousel-control-next"
                            type="button"
                            data-bs-target="#videoCarousel"
                            data-bs-slide="next"
                        >
                            <span
                                className="carousel-control-next-icon"
                                aria-hidden="true"
                            />
                            <span className="visually-hidden">Next</span>
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
